import { appRoutes } from "../../../constants/appRoutes";

export const aboutRoute = {
    path: appRoutes.about.path,
    lazy: () => import('../../../pages/About'),
}